import { getSentryCarrier as e } from "./chunk1174.js";
import { getStackAsyncContextStrategy as n } from "./chunk1177.js";
function a(r) {
  const t = e(r);
  return t.acs ? t.acs : n();
}
export {
  a as getAsyncContextStrategy
};
